const Footer = () => {
  return (
    <footer className="flex flex-col bg-red-600 w-full mt-5">
      <div className="flex flex-col justify-start items-end h-full w-full gap-32 p-10 sm:flex-row-reverse sm:items-start">
        <div className="h-full flex flex-col items-end">
          <span className="w-52 text-right text-xl border-b-4 border-black">
            خدمات مشتریان
          </span>
          <p>سوالات متداول</p>
          <p>شرایط تحویل کالا </p>
          <p>شرایط استفاده از کوپن </p>
          <p>تخفیف</p>
          <p>شرایط حفظ حریم خصوصی</p>
        </div>

        <div className="w-64 h-full flex flex-col items-end">
          <span className="w-full text-xl border-b-4 text-right border-black">
            با همراهایپر همراه باشید
          </span>
          <p> درباره ما</p>
          <p>تماس با ما </p>
          <p>درخواست نمایندگی </p>
        </div>

        <div className="w-64 h-full flex flex-col items-end">
          <span className="w-full text-xl border-b-4 text-right border-black">
            ای نماد
          </span>
          <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=107539&Code=NKH2PvMipgZpgWhTl2Y4uyXicomz2tQh'>
            <img className="enamad" referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=107539&Code=NKH2PvMipgZpgWhTl2Y4uyXicomz2tQh' Code='NKH2PvMipgZpgWhTl2Y4uyXicomz2tQh' />
            </a>
        </div>


      </div>

      

      <div className="w-full h-10 bg-gray-500 flex items-center justify-center">
        <span> 2023&copy; hamraHyper</span>
      </div>
    </footer>
  );
};

export default Footer;
